
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";  

import PageBase from "../../PageBase.vue";
import ChildSurvey from './ChildSurvey.vue';
import Tooltip from "@/components/survey/Tooltip.vue";
 
import "@/store/modules/application";
const applicationState = namespace("Application");

import { stepInfoType, stepResultInfoType } from "@/types/Application";
import { stepsAndPagesNumberInfoType } from "@/types/Application/StepsAndPages";


@Component({
    components:{
      ChildSurvey,
      PageBase,
      Tooltip
    }
})
export default class ChildrenInfo extends Vue {

    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.State
    public deceasedName!: string;

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void


    currentStep =0;
    currentPage =0;
    showTable = true;
    childData = [];
    anyRowToBeEdited = null;
    editId = null; 
    incompleteError =  false;   
    childExists = null; 
    childCompleted = null;
    updated = 0;
    updatedChildren = 0;
    showAdoptedInfo = false;
    showStepChildrenInfo = false;
    showElseAdoptedChildInfo = false;
    showChildInLawInfo = false;
    showChildrenInfo = false;
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('child-info-survey')
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {       
        this.showTable = value;
    }

    public populateSurveyData(childValue) {

        const currentIndexValue = this.childData?.length > 0 ? this.childData[this.childData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newChildren = { ...childValue, id };
        this.childData = [...this.childData, newChildren];

        this.showTable = true; 
        this.resetChildrenRelatedPages(this.childData);
    }

    public deleteRow(rowToBeDeleted) {
       
        this.childData = this.childData.filter(data => {
            return data.id !== rowToBeDeleted;
        }); 
        this.resetChildrenRelatedPages(this.childData);
        this.surveyHasError();
    }

    public editRow(editedRow) {
        this.childData = this.childData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
        this.surveyHasError();
        this.resetChildrenRelatedPages(this.childData);
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage()
    }

    public onNext() {
        if(!this.incompleteError)    
            Vue.prototype.$UpdateGotoNextStepPage()
    }

    created() {

        if (this.step.result?.childExists) {
            this.childExists = this.step.result.childExists;
        }

        if (this.step.result?.childrenSurvey?.data) {
            this.childData = this.step.result.childrenSurvey.data;
        }       
        
        if (this.step.result?.childCompleted) {
            this.childCompleted = this.step.result.childCompleted;
        }  
    }

    mounted(){
        this.updated = 0;
        Vue.nextTick(()=>this.surveyHasError());
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;        
    }

    public surveyHasError(){
        let progress = this.childData.length==0? 50 : 100;
        
        if(this.childExists == 'No') progress =100;

        this.incompleteError =  false;        
        for(const child of this.childData){
            if (!child.childName || !child.childIsAlive){            
                this.incompleteError = true;  
                progress = 50;    
                break
            }
        }        
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
    }
    
    public isDisableNext() {
        return (this.childExists == null || (this.childExists == 'Yes' && this.childData?.length <= 0 ) || 
            !this.childCompleted || this.childCompleted == 'No');
    }

    beforeDestroy() {
        this.surveyHasError();  
        
        let childInfo = this.getChildrenResults();        
       
        if(this.childExists == 'No')
            childInfo = null

        this.UpdateStepResultData({step:this.step, data: {childExists: this.childExists, childrenSurvey: childInfo, childCompleted: this.childCompleted}})       
    }

    public getChildrenResults(){
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        for(const child of this.childData)
        {
            questionResults.push({name:'childrenSurvey', value: this.getChildrenInfo(child), title:'Children '+child.id +' Information', inputType:''})
        }
        
        return {data: this.childData, questions:questionResults, pageName:'Children Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getChildrenInfo(child){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+child.childName);                
        resultString.push(Vue.filter('styleTitle')("Alive: ")+(child.childIsAlive=='y'?'Yes':'No'));
        if(child.childIsAlive=='y' && child.childIsAdult)
            resultString.push(Vue.filter('styleTitle')("Adult: ")+(child.childIsAdult=='y'?'Yes':'No'));
        
        
        return resultString;
    }  

    public resetChildrenRelatedPages(childData?) {
    //TODO
        // const stPgNo: stepsAndPagesNumberInfoType = this.$store.state.Application.stPgNo;   
        // const p = stPgNo.RFLM;

        // const pages = [ 
        //     p.ParentingArrangements,
        //     p.ParentalResponsibilities,
        //     p.ParentingTime,
        //     p.ParentingOrderAgreement,
        //     p.BestInterestsOfChild,
        //     p.ChildSupportCurrentArrangements,
        //     p.AboutChildSupportOrder,
        //     p.SpecialAndExtraordinaryExpenses,
        //     p.ContactWithChild,
        //     p.ContactWithChildOrder,
        //     p.AboutContactWithChildOrder,
        //     p.ContactWithChildBestInterestsOfChild,
        //     p.GuardianOfChild,           
        //     p.ReviewYourAnswersRFLM
        // ]
        // Vue.filter('setProgressForPages')(p._StepNo, pages,50);    

    }
}
